const userType = {
    Unknown: 0,
    Customer: 1,
    User: 2,
    AccountOwner: 3,
    MasterAdmin: 4
}
export default userType